import { render, staticRenderFns } from "./AccessionDistribution.vue?vue&type=template&id=ae524522&scoped=true&"
import script from "./AccessionDistribution.vue?vue&type=script&lang=js&"
export * from "./AccessionDistribution.vue?vue&type=script&lang=js&"
import style0 from "./AccessionDistribution.vue?vue&type=style&index=0&id=ae524522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae524522",
  null
  
)

export default component.exports